import { createApiAction } from '@app/packages/api/utils'
import type { ApiStatistics } from '@app/packages/api/v2/types/entities'
import type { GetStatisticsQuery } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getStatistics = (query?: GetStatisticsQuery) =>
  createApiAction('getStatistics', dispatch => dispatch<{ data: ApiStatistics }>({ method: 'GET', endpoint: v2Path('/api/v2/statistics', query) }))
